import type { Format, FormatScoreInput, RoundResult } from "./types.js";
import {
  allowanceNote,
  bestTeamNetOnHole,
  buildScoreMap,
  computeHandicaps,
  describeSegmentPoints,
  holeCount,
  holeNumbersInPlay,
  scoreSegmentsByTotal,
} from "./util.js";

/** The better of the side's two net scores — shared by `score` and the side breakdown. */
function betterBall({ round, course, players, scores }: FormatScoreInput) {
  const scoreMap = buildScoreMap(scores);
  const handicaps = computeHandicaps(round, course, players);
  return (team: string[], hole: number) => bestTeamNetOnHole(scoreMap, handicaps, team, hole);
}

export const fourBall: Format = {
  id: "fourBall",
  name: "Four-Ball / Best Ball",
  scope: "team",
  uses: { teamPoints: true, handicapAllowance: true },
  entry: "perPlayer",
  defaults: { handicapAllowance: 90 },
  configSchema: { type: "object", properties: {} },
  perHoleSchema: null,

  score(input): RoundResult {
    const { round, course, players, onlyHoles } = input;
    return scoreSegmentsByTotal(
      round,
      players,
      holeNumbersInPlay(round, course),
      betterBall(input),
      onlyHoles,
    );
  },

  sideValueOnHole: betterBall,

  describeRules(round, _players, course) {
    return [
      `Four-ball / best ball across ${holeCount(round, course)} holes: each team's score on a hole is the better of its two players' net scores.`,
      describeSegmentPoints(round),
      `Handicap allowance: ${round.handicapAllowance}%${allowanceNote(round, course)}.`,
    ];
  },
};
